export default __webpack_public_path__ + "static/media/ProductPageImage06.5b186fc6.jpg";